export default {
    countries: 'کشورها',
    countriesTitle: 'عنوان',
    countriesStatus: 'وضعیت',
    editCountries: 'ویرایش کشور ها ',
    addCountries: 'کشور جدید',
    isArabCountry: 'کشور عربی میباشد ؟',
    countriesCode: 'کد کشور (IR)',
    dialCode: 'کد شماره گیری کشور (98)',
}